/**
 * Bildregistry der zehn Kapitelillustrationen.
 *
 * Je Kapitel eine Szene im 3D-Trickfilmstil: zwei bis drei Jugendliche in
 * Nahaufnahme bei genau der Taetigkeit, um die es im Kapitel geht. Die Dateien
 * liegen als AVIF (klein) und WebP (Fallback) in
 * src/assets/images/konzept/ und sind 720px breit - die Spalte der
 * Illustration ist 200px breit (mobil hoechstens 260px), das reicht auch fuer
 * hochaufloesende Bildschirme.
 *
 * Statische Importe statt dynamischer Pfade, weil der Webpack-Build von CRA
 * die Dateien nur so mitnimmt und mit Hash-Namen versieht - dieselbe
 * Konvention wie in pages/SupporterRegister/photos.js.
 */

import kapitel01Avif from '../../../../assets/images/konzept/kapitel-01.avif'
import kapitel01Webp from '../../../../assets/images/konzept/kapitel-01.webp'
import kapitel02Avif from '../../../../assets/images/konzept/kapitel-02.avif'
import kapitel02Webp from '../../../../assets/images/konzept/kapitel-02.webp'
import kapitel03Avif from '../../../../assets/images/konzept/kapitel-03.avif'
import kapitel03Webp from '../../../../assets/images/konzept/kapitel-03.webp'
import kapitel04Avif from '../../../../assets/images/konzept/kapitel-04.avif'
import kapitel04Webp from '../../../../assets/images/konzept/kapitel-04.webp'
import kapitel05Avif from '../../../../assets/images/konzept/kapitel-05.avif'
import kapitel05Webp from '../../../../assets/images/konzept/kapitel-05.webp'
import kapitel06Avif from '../../../../assets/images/konzept/kapitel-06.avif'
import kapitel06Webp from '../../../../assets/images/konzept/kapitel-06.webp'
import kapitel07Avif from '../../../../assets/images/konzept/kapitel-07.avif'
import kapitel07Webp from '../../../../assets/images/konzept/kapitel-07.webp'
import kapitel08Avif from '../../../../assets/images/konzept/kapitel-08.avif'
import kapitel08Webp from '../../../../assets/images/konzept/kapitel-08.webp'
import kapitel09Avif from '../../../../assets/images/konzept/kapitel-09.avif'
import kapitel09Webp from '../../../../assets/images/konzept/kapitel-09.webp'
import kapitel10Avif from '../../../../assets/images/konzept/kapitel-10.avif'
import kapitel10Webp from '../../../../assets/images/konzept/kapitel-10.webp'

export const ILLUSTRATIONEN = {
	1: { avif: kapitel01Avif, webp: kapitel01Webp },
	2: { avif: kapitel02Avif, webp: kapitel02Webp },
	3: { avif: kapitel03Avif, webp: kapitel03Webp },
	4: { avif: kapitel04Avif, webp: kapitel04Webp },
	5: { avif: kapitel05Avif, webp: kapitel05Webp },
	6: { avif: kapitel06Avif, webp: kapitel06Webp },
	7: { avif: kapitel07Avif, webp: kapitel07Webp },
	8: { avif: kapitel08Avif, webp: kapitel08Webp },
	9: { avif: kapitel09Avif, webp: kapitel09Webp },
	10: { avif: kapitel10Avif, webp: kapitel10Webp }
}
